import * as actionTypes from "./ActionTypes";

export const initPayment = () => {
  return {
    type: actionTypes.INIT_PAYMENT
  };
};

